<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Employee Import</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
          <v-file-input placeholder="CSV of employee data" prepend-icon="mdi-file" label="Employee Data" rounded dense
            flat outlined show-size v-model="file"></v-file-input>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
          <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Import_Employee.csv">
            <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
              class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
              Download import CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
      </v-row>

      <v-col cols="12" sm="12" md="12">
        <template v-if="load == true">
          <v-data-table :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable" dense
            :search="search" :loading="output_load">
          </v-data-table>
        </template>
      </v-col>

      <!-- shiv new code -->
      <v-col cols="12" sm="12" md="12">
        <template v-if="load == false">
          <v-simple-table class="mytable">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">EmployeeCode</th>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">Institute Email</th>
                  <th class="text-left">Aadhaar No</th>
                  <th class="text-left">Pan No</th>
                  <th class="text-left">Contact</th>
                  <th class="text-left">Emloyee Type</th>
                  <th class="text-left">Designation</th>
                  <th class="text-left">Date of birth(DD-MM-YYYY)</th>
                  <th class="text-left">Date of joining(DD-MM-YYYY)</th>
                  <th class="text-left">Section</th>
                  <th class="text-left">Gender</th>
                  <th class="text-left">Shift</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>E11148</td>
                  <td>Vikas Chauhan</td>
                  <td>vikas.chauhan@vit.edu</td>
                  <td></td>
                  <td></td>
                  <td>880055XXXX</td>
                  <td>Teacher</td>
                  <td>Teacher</td>
                  <td>12-01-2018</td>
                  <td>12-01-2018</td>
                  <td>Primary</td>
                  <td>Male</td>
                  <td>Afternoon</td>
                </tr>
                <tr>
                  <td class="mandatory">Mandatory</td>
                  <td class="mandatory">Mandatory</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    Note: Please start from row #2. Make sure that employee code
                    is not matching with student registration numer.(Its better
                    to append E to employee code)
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </v-col>
      <!-- shiv code end -->
    </v-card>
  </div>
</template>


<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  /*
      Defines the data used by the component
    */
  data() {
    return {
      isallowed: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      file: null,
      statuslist: "",
      load: false,
      loading3: false,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      search: "",
      headers: [
        { text: "Sr.NO", value: "serial_number" },
        { text: "Status", value: "status" },
        { text: "Login Id", value: "employeecode" },
        { text: "Reason", value: "reason" },
        { text: "Birthdate", value: "birthdate" },
        { text: "Dateofjoining", value: "dateofjoining" },
        { text: "Employeetype", value: "employeetype" },
        { text: "Designation", value: "designation" },
        { text: "Section", value: "section" },
        { text: "Gender", value: "gender" },
        { text: "Shift",   value: "shift"   },
      ],

      output_load: false,
    };
  },

  methods: {
    submitFile() {
      if (this.file == null) {
        alert("Please select the file!");
      } else {
        this.output_load = true;
        let formData = new FormData();
        //console.log(this.file.size);
        formData.append("file", this.file);

        //console.log(formData)
        axios
          .post("RoleManagement/importEmployee", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.flag == "YES") {
              this.statuslist = res.data.statuslist;
              this.isallowed = res.data.isallowed
              this.load = true;
              //this.getsubjectoffering()
              // Object.assign(this.courselist[this.editedIndex], this.editedItem);
            } else if (res.data.flag == "No") {
              this.showSnackbar("red", res.data.snackbar);
              this.isallowed = res.data.isallowed
              this.overlay = false;
            }
          })
          .catch(function () {
            console.log("FAILURE!!");
          })
          .finally(() => {
            this.output_load = false;
          });
      }

      //     }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    /*
        Handles a change on the file upload
      */
  },
};
</script>
<style scoped>
.downbtn {
  float: right;
}

/* new css */
table,
th {
  padding: 10px;
  border: 1px solid black;
  border-collapse: collapse;
  background: #0f2027;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.downbtn:hover {
  color: white !important;
}
.mandatory {
  color: red;
}
</style>
